import React from 'react';
import { motion } from 'framer-motion';
export function SectionDivider() {
  return <div className="flex items-center justify-center w-full py-16 opacity-60" data-id="element-226">
      <div className="h-[1px] w-24 bg-gradient-to-r from-transparent to-mystic-gold" data-id="element-227"></div>
      <motion.div className="mx-4 text-mystic-gold text-xl" animate={{
      rotate: [0, 180, 360],
      scale: [1, 1.1, 1]
    }} transition={{
      duration: 20,
      repeat: Infinity,
      ease: 'linear'
    }} data-id="element-228">
        ✦
      </motion.div>
      <div className="h-[1px] w-24 bg-gradient-to-l from-transparent to-mystic-gold" data-id="element-229"></div>
    </div>;
}